/// Minimal quickview handler: only show and hide (no insert/prepare)
var scrimquickview
const chatActions = require('../chat/chat-actions')
export function HTMLselect(entity, id, source, quickviewHTML, htmlQf) {

    scrimquickview = document.getElementById('scrim_quickview')

    loadquickview(quickviewHTML)

    htmlQf.quickviewHTML = document.getElementById(id)

}

function loadquickview(quickviewHTML) {
    const body = document.body
    body.insertAdjacentHTML("beforeend", quickviewHTML)
}

export function show(detail, htmlQf) {
    if (!scrimquickview) scrimquickview = document.getElementById('scrim_quickview')

    htmlQf.quickviewHTML.classList.add('quickview-show')
    scrimquickview.classList.add('scrim-show')
    const entity = htmlQf.quickviewHTML && htmlQf.quickviewHTML.getAttribute('data-entity')
    if (entity && scrimquickview) {
        scrimquickview.setAttribute(
            'data-detail',
            JSON.stringify({
                click: [
                    { dest: 'ripple' },
                    { dest: entity, elem: 'quickview', act: 'hide' },
                ],
            })
        )
    }
}

export function hide(detail, htmlQf) {

    htmlQf.quickviewHTML.classList.add('quickview-hide')
    scrimquickview.classList.add('scrim-hide')

    chatActions.clearChat()

    remove(() => {
        htmlQf.quickviewHTML.classList.remove('quickview-hide');
        htmlQf.quickviewHTML.classList.remove('quickview-show');
        
        scrimquickview.removeAttribute('data-detail')
        scrimquickview.classList.remove('scrim-show')
        scrimquickview.classList.remove('scrim-hide')
    })
}

function remove(callback) {
    setTimeout(() => { callback() }, 300)
}